const radioHeight = (width: number, height: number) => {
  let percent = width / 350;
  return Math.floor(height / percent);
};

export interface IWaterItem {
  [key: string]: any;
  width?: number;
  height?: number;
}

export default function (original: any[], defaultWidth: number = 0, defaultHeight: number = 0) {

  let column1 = [] as IWaterItem[];
  let column2 = [] as IWaterItem[];

  let column1height = 0;
  let column2height = 0;

  original.forEach((it: IWaterItem, index: number) => {
    const one = {
      ...it,
      originalIndex: index
    };

    const oneWidth = !one.width && defaultWidth > 0 ? defaultWidth : Number(one.width);
    const oneHeight = !one.height && defaultHeight > 0 ? defaultHeight : Number(one.height);
    if (column1height <= column2height) {
      column1.push(one);
      column1height += radioHeight(Number(oneWidth), Number(oneHeight));
    } else {
      column2.push(one);
      column2height += radioHeight(Number(oneWidth), Number(oneHeight));
    }
  });

  return [column1, column2];
}
